import { gsap } from 'gsap';
import Lenis from 'lenis';
export class MainScroll {
  lenis?: Lenis;
  isLocked: boolean;

  constructor() {
    this.isLocked = false;
    this.lenis = new Lenis({
      wrapper: document.body,
      // Lerp OR duration OR easing, duration will override lerp and if either of them are defined easing will be useless.
      lerp: 0.08,
      // duration: 3,
      // The easing function to use for the scroll animation, our default is custom but you can pick one from Easings.net. Useless if lerp defined
      // easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      syncTouch: true,
      syncTouchLerp: 0.1,
      touchInertiaMultiplier: 20,
      wheelMultiplier: 1,
      touchMultiplier: 1,
      infinite: false,
      autoResize: true,
      // Help safari with flickering issue
      wheelEventsTarget: document.body,
    });
    this.addEvents();
    return this;
  }

  addEvents() {
    // boucle pour notre scroll
    gsap.ticker.add((time) => {
      if (!this.lenis?.isStopped) {
        this.lenis?.raf(time * 1000);
      }
    });
    gsap.ticker.lagSmoothing(0);

    // on va ajouter les ancres pour le scroll
    const anchors = window.document.querySelectorAll('[data-scrollanchor]');
    if (anchors.length > 0) {
      anchors.forEach((ancre) => {
        const elemToGo = document.querySelector(ancre.dataset.scrollanchor);
        if (elemToGo) {
          ancre.addEventListener('click', (e) => {
            e.preventDefault();
            this.lenis.scrollTo(elemToGo, {
              duration: 2,
              offset: 0,
              lerp: 0.1,
              force: true,
              lock: true,
              immediate: false,
            });
          });
        }
      });
    }

    // interuptor pour arrêter relancer lenis
    const interuptors = window.document.querySelectorAll('[data-scrollinterruptor]');
    if (interuptors.length > 0) {
      interuptors.forEach((interuptor) => {
        interuptor.addEventListener('click', (e) => {
          this.lenis?.stop();
        });
      });
    }

    const lockers = window.document.querySelectorAll('[data-lockbodyscroll]');
    if (lockers.length > 0) {
      lockers.forEach((locker) => {
        locker.addEventListener('click', (e) => {
          e.preventDefault();
          this.lockBodyAndScroll();
        });
      });
    }
  }

  scrollTo(value: number | string | HTMLElement) {
    if (!this.lenis) {
      console.log('pas lenis');
    } else {
      this.lenis.scrollTo(value, {
        duration: 2,
        offset: 0,
        force: true,
        lock: true,
      });
    }
  }

  lockBodyAndScroll() {
    if (!this.lenis.isStopped) {
      this.lenis?.stop();
    }
  }
}
